export default class Popupalert {
	constructor(container) {
		this.clickFavouritesElement = container;
		this.popupElement = document.querySelector('.popup-alert');
		this.closeButton = document.querySelector('.popup-alert__close-button');
		this.closePopupButton = document.querySelector('.popup-alert__btn');

		this.clickFavouritesElement.addEventListener('click', () => {
			this.popupElement.classList.add('active');
			if (this.clickFavouritesElement.classList.contains('wishlist__share-button')) {
				this.popupElement.querySelector('.wishlist__share-content').classList.add('active');
			} else {
				this.popupElement.querySelector('.wishlist__clear-result-content').classList.add('active');
			}
		});

		this.closeButton.addEventListener('click', () => {
			this.popupElement.classList.remove('active');
			this.popupElement.querySelectorAll('section').forEach((el) => {
				el.classList.remove('active');
			})
		});

		this.closePopupButton.addEventListener('click', () => {
			this.popupElement.classList.remove('active');
			this.popupElement.querySelectorAll('section').forEach((el) => {
				el.classList.remove('active');
			})
		});
	}
}

